module.exports = __webpack_public_path__ + "img/adv.a40da6d2.png";